var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[(_vm.ready)?_c('PushController',{ref:"push"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }